import React from "react";
import Reveal from "./Reveal";

export default function WhyNumbers() {
  return (
    <section className="relative py-24 md:py-32 bg-gradient-to-b from-[#0f1724] to-[#151e31] text-white overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.1] pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 50% 40%, rgba(229,214,178,0.4) 0%, transparent 50%)",
        }}
      />
      <div className="relative max-w-5xl mx-auto px-6">
        <div className="grid md:grid-cols-[auto_1fr] gap-12 md:gap-20 items-center">
          <Reveal>
            <div className="text-center md:text-left">
              <span
                className="font-display text-[140px] md:text-[200px] leading-none tracking-tight"
                style={{
                  background: "linear-gradient(135deg, #e9d8a6 0%, #c9b37d 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                }}
              >
                888
              </span>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div>
              <h2 className="font-display text-[36px] md:text-[48px] leading-[1.1] tracking-tight mb-6">
                Why <span className="italic font-light text-[#e9d8a6]">$8.88/month?</span>
              </h2>
              <p className="font-body text-[17px] md:text-[19px] leading-relaxed text-white/80 mb-5">
                In many cultures,{" "}
                <span className="text-white font-medium">
                  888 represents luck, abundance, and new beginnings
                </span>{" "}
                — triple alignment, the universe saying “this is the moment.”
                We chose this number on purpose.
              </p>
              <p className="font-body text-[17px] md:text-[19px] leading-relaxed text-white/80">
                <span className="text-white font-medium">
                  Because real direction shouldn’t cost $200/hour.
                </span>{" "}
                It should cost less than a round at the coffee shop.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
